const call = (playlist) => {
    return {
        CurrentTrack: 0,
        AudioSourceUrl: '',
        TrackTitle: '',

        Playlist: [...playlist],

        AudioPlayerEl: null,

        Init(audioPlayerEl) {
            this.AudioPlayerEl = audioPlayerEl
            this.StartTrack(this.CurrentTrack);
        },

        StartTrack(trackNumber) {
            console.log(trackNumber + " playlist" + JSON.stringify(this.Playlist))
            const newTrack = this.Playlist[trackNumber]

            this.CurrentTrack = trackNumber
            this.AudioSourceUrl = newTrack.Path
            this.TrackTitle = newTrack.Name
        },

        NextTrack() {
            if (this.CurrentTrack < this.Playlist.length) {
                this.StartTrack(this.CurrentTrack + 1);

            }

        },

        PreviousTrack() {
            if (this.CurrentTrack - 1 > 0) {
                this.StartTrack(this.CurrentTrack - 1);

            }

        },

        OnEnded() {
            this.NextTrack()
        },
    };
};

export default call;